import iconZap from '../../../assets/landingPage/icon-badge-shield.svg';
import iconCheckGreen from '../../../assets/landingPage/icon-check.svg';
import iconSecureAccess from '../../../assets/landingPage/icon-secure-access.svg';
import iconFastOnboarding from '../../../assets/landingPage/icon-fast-onboarding.svg';
import iconTrustedNetwork from '../../../assets/landingPage/icon-trusted-network.svg';
import iconArrowRight from '../../../assets/landingPage/icon-arrow-right.svg';
import iconLock from '../../../assets/landingPage/icon-lock.svg';
import iconFoodProcessor from '../../../assets/landingPage/icon-food-processor.svg';
import iconCheckBlue from '../../../assets/landingPage/icon-check-blue.svg';
import iconServiceProviders from '../../../assets/landingPage/icon-service-providers.svg';
import iconCheckPurple from '../../../assets/landingPage/icon-check-purple.svg';
import iconCheckWhite from '../../../assets/landingPage/icon-check-white.svg';
import iconCheckDark from '../../../assets/landingPage/icon-check-dark.svg';
import iconSearch from '../../../assets/landingPage/icon-search.svg';

// Registry of the small brand/glyph icons used by the custom landing-page sections
// (SectionHeroBanner, SectionCardGrid, SectionCtaBanner). These are exported as
// static assets from the Figma design rather than Console-managed "image" fields,
// since the built-in image field type only accepts uploaded Sharetribe imageAssets -
// too much friction for a handful of small line icons that belong to this page's design.
const landingPageIcons = {
  zap: iconZap,
  checkGreen: iconCheckGreen,
  secureAccess: iconSecureAccess,
  fastOnboarding: iconFastOnboarding,
  trustedNetwork: iconTrustedNetwork,
  arrowRight: iconArrowRight,
  lock: iconLock,
  foodProcessor: iconFoodProcessor,
  checkBlue: iconCheckBlue,
  serviceProviders: iconServiceProviders,
  checkPurple: iconCheckPurple,
  checkWhite: iconCheckWhite,
  checkDark: iconCheckDark,
  search: iconSearch,
};

export default landingPageIcons;
